module.exports = __webpack_public_path__ + "static/media/charging-station.a182de74.svg";